import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css'// 默认主题
import ElementUI from 'element-ui'
Vue.use(ElementUI, {
  size: 'small'
})

// import 'babel-polyfill'//解决ie打开空白问题
import '@/assets/font/iconfont.css'; // 全局样式
import prototypeJs from './utils/prototype.js'

// 全局自定义指令
import waves from '@/directives/waves'
Vue.directive('waves',waves)

import * as directives from './directives/index.js'
Object.keys(directives).forEach(key=>{
  Vue.directive(key,directives[key])
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    /**
     * 挂载全局时间总线
     */
    Vue.prototype.$bus = this;
  }
}).$mount('#app')
